import { createSelector } from 'reselect';

export const getFilteredChefs = createSelector(
  [
    state => state.restaurants.chefs,
    state => state.restaurants.filterTags,
    state => state.restaurants.filterTagsIcon,
    state => state.restaurants.selectedFilterTags,
  ],
  (chefs, filterTags, filterTagsIcon, selectedFilterTags) => {
    if (
      selectedFilterTags.length === 0 ||
      selectedFilterTags.length === filterTags.length
    ) {
      // all selected
      return [chefs, 'All', []];
    }

    const filteredChefs = chefs;
    const selectedIcons = selectedFilterTags.map(tag => filterTagsIcon[tag]);

    return [filteredChefs, selectedFilterTags.join(', '), selectedIcons];
  },
);
